import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {Autocomplete} from "@material-ui/lab";
import {ajustesResources, validadorClienteResources} from "../endpoints";
import useToken from "../useToken";

class DialogEditarCantidadConteo extends React.Component{
    constructor(props) {
        super(props);
        if(props.tipo === "agrupado"){
            this.state = {
                cantidad_final: "",
                id_codigo_tipo: props.conteo.id_codigo_tipo,
                barra: props.conteo.codigo,
                material: props.conteo.articulo,
                descripcion_material: props.conteo.descripcion,
                cantidad_capt: props.conteo.cantidad,
                motivos: [],
                tag: this.props.tag,
                motivo: "",
                comentario:'',
                user: useToken.getUser(),
                origen: props.origen,
                validadores:[],
                validador:null
            }
        }
        else{
            this.state = {
                id_conteo: props.conteo.id,
                cantidad_final: "",
                barra: props.conteo.codigo,
                material: props.conteo.articulo,
                descripcion_material: props.conteo.descripcion,
                cantidad_capt: props.conteo.cantidad,
                motivos:[],
                motivo: "",
                comentario:'',
                user: useToken.getUser(),
                origen: props.origen,
                validadores:[],
                validador:null
            }
        }
    }

    ajustesMotivos = () =>{
        ajustesResources.getMotivosAjustes().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            if (this.state.user && this.state.user.app === 'natura') {
                const defecto = result.find(m => m.id === 1) || null;
                this.setState({ motivos: result, motivo: defecto });
            } else {
                this.setState({ motivos: result });
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    ajustarCantidad = () =>{
        if(this.props.tipo === "desagrupado"){
            const datosConteo ={
                id: this.state.id_conteo,
                cantidad: this.state.cantidad_final,
                id_motivo: this.state.motivo.id,
                comentario: this.state.comentario,
                origen_ajuste: this.state.origen,
                usuario_afectado: this.state.validador?.cod_operador ?? null
            }
            ajustesResources.ajustarCantidadDesagrupado(datosConteo).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado","error")
                console.log(error)
            });
        }
        else{
            const datosConteo ={
                tag: this.state.tag,
                barra: this.state.barra,
                id_codigo_tipo: this.state.id_codigo_tipo,
                cantidad_final: this.state.cantidad_final,
                id_motivo: this.state.motivo.id,
                comentario: this.state.comentario,
                origen_ajuste: this.state.origen,
                usuario_afectado: this.state.validador?.cod_operador ?? null
            }
            ajustesResources.ajustarCantidadAgrupado(datosConteo).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado","error")
                console.log(error)
            });
        }
    }

    handleChange = e =>{
        this.setState({[e.target.name]: e.target.value});
    }


    obtenerValidadorCliente = () =>{
        this.setState({openSnack:false, severity: null, message:null})
        validadorClienteResources.getValidadorCliente().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({validadores:result.validadores})
            }
            else if (result.status_code === 401){
                this.setState({cargando:false,openSnack:true, severity:result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    componentDidMount() {
        document.addEventListener('keyup', this.getEventType, false);
        this.ajustesMotivos()
        if(this.state.user.app === 'walmart' || this.state.user.app ==='walmart_parciales'){
            this.obtenerValidadorCliente();
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.getEventType, false);
    }

    getEventType = (event) =>{
        if(event.keyCode === 13){
            if(this.state.motivo && this.state.cantidad_final){
                this.ajustarCantidad()
            }
        }
    }

    render() {
        return(
            <Dialog
                open={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Modificar cantidad capturada</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12}>
                            Cód. escaneado: {this.state.barra}
                        </Grid>
                        <Grid item xs={12}>
                            Material: {this.state.material}
                        </Grid>
                        <Grid item xs={12}>
                            Descripción material: {this.state.descripcion_material}
                        </Grid>
                        <Grid item xs={12}>
                            Cantidad actual: {this.state.cantidad_capt}
                        </Grid>
                        <Grid item xs={12}>
                            Cantidad real : <TextField value={this.state.cantidad_final} autoFocus={true} name="cantidad_final" fullWidth onChange={this.handleChange}/>
                        </Grid>
                        <Grid item xs={12}>
                            Seleccione un motivo:
                            <Autocomplete
                                id="size-small-standard"
                                value={ this.state.motivo}
                                onChange={(event, newValue) => {
                                    if(newValue === null) {
                                        this.setState({motivo: ""})
                                    }
                                    else{
                                        this.setState({motivo: newValue})
                                    }
                                }}
                                size="small"
                                options={this.state.motivos}
                                noOptionsText={"No hay opciones"}
                                getOptionLabel={(option) => option.descripcion|| ""}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" label="Motivo" placeholder="Disponibles"
                                               value={params.inputProps?.value ?? ""}/>
                                )}
                            />
                        </Grid>
                        {this.state.motivo.id === 4 && (this.state.user.app === 'walmart' || this.state.user.app === 'walmart_parciales' )&&
                        <Grid item xs={12}>
                            Comentario: <TextField value={this.state.comentario} name="comentario" fullWidth onChange={this.handleChange}/>
                        </Grid> }

                        { this.state.user.app === 'walmart' && this.state.user.perfil !== 'validador walmart' && this.state.user.perfil !== 'analista walmart' &&
                            <Grid item xs={12}>
                                    Seleccione un validador:
                                    <Autocomplete
                                        id="size-small-standard"
                                        value={ this.state.validador}
                                        onChange={(event, newValue) => {
                                            this.setState({ validador: newValue });
                                        }}
                                        size="small"
                                        options={this.state.validadores}
                                        noOptionsText={"No hay opciones"}
                                        getOptionLabel={(option) =>
                                            option ? `${option.nombre1} ${option.apellido1}` : ""
                                        }                                        renderInput={(params) => (
                                            <TextField {...params} variant="standard" label="Validador" placeholder="Disponibles"
                                                       value={params.inputProps?.value ?? ""}/>
                                        )}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                    />
                            </Grid> }
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    <Button disabled={(this.state.motivo.id === 4 && !this.state.comentario && (this.state.user.app === 'walmart' || this.state.user.app === 'walmart_parciales')) || !this.state.motivo || !this.state.cantidad_final} variant="contained" onClick={this.ajustarCantidad} color="primary">
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default DialogEditarCantidadConteo;